/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import { useRouter } from 'next/router';
import { ListGridToggle } from 'modules/Listings/components/ListGridToggle/ListGridToggle';
import { ListFilterToggle } from 'modules/Listings/components/ListFilterToggle/ListFilterToggle';
import { useCurrentStore } from 'modules/Listings/store/useCurrentStore';
import { observer } from 'mobx-react-lite';
import { CommunitySearchMenu } from 'components/CommunitySearchMenu';
import { FilterTabs, IFilter } from 'modules/Listings/components/AllStarTemplateToggle';
import { useIsLoggedIn } from 'modules/Auth/hooks';
import { wrapper, hideButton, searchAndStarPanel, toggleAndPanel } from './ListHeading.styles';
import { Sorter } from '../Sorter/Sorter';

export const ListHeading_ = (): JSX.Element => {
  const router = useRouter();
  const { query, pathname } = router;
  const store = useCurrentStore();
  const isFilterable = store.isFilterable;
  const isLoggedIn = useIsLoggedIn();
  const isAppTemplateEnable = pathname.includes('apps');

  const listFilterType = (query?.listFilterType as string) || 'all';
  const onChange = ({ filterParams, id }: IFilter) => {
    router
      .replace(
        {
          pathname: router.pathname.startsWith('/explore/apps') ? '/explore/apps/[listFilterType]' : router.pathname,
          query: { ...query, listFilterType: id },
        },
        undefined,
        { shallow: true },
      )
      .then(() => {
        store.setDefaultParams(filterParams);
      });
  };

  return (
    <div className={wrapper}>
      <div className={searchAndStarPanel}>
        {pathname !== '/explore' && <CommunitySearchMenu />}
        {isFilterable && (
          <div className={hideButton}>
            <ListFilterToggle />
          </div>
        )}
        <ListGridToggle />
      </div>
      <div className={toggleAndPanel}>
        {(isAppTemplateEnable || isLoggedIn) && (
          <FilterTabs
            activeToggle={listFilterType}
            onToggle={onChange}
            showTemplate={isAppTemplateEnable}
            showStarred={isLoggedIn}
            showPublic={isLoggedIn}
          />
        )}
        <Sorter />
      </div>
    </div>
  );
};

export const ListHeading = observer(ListHeading_);
